import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

export const GlobalStyles = ({ styles, ...props }: any) => {
  const stylesObj = {
    ...styles,
    /*
      Consumers that import the `CssBaseline` component will automatically have the `.sr-only` class
      (and any other global classnames attached to the CssBaseline) available to them. 
      However, Connect was built without using MUI's CSS reset and so adding the `CssBaseline`
      in that app causes some of the layout to shift. 
      Rather than inserting it and then having to track down every layout issue, 
      this component can be used to inject custom class names WITHOUT injecting the CSS reset contained in `CssBaseline`.

      Basically, this is used entirely for backwards compatibility in Connect, but all new apps should use the CssBaseline
    */
    '.sr-only': {
      position: 'absolute !important',
      overflow: 'hidden !important',
      clip: 'rect(0 0 0 0) !important',
      height: '1px !important',
      width: '1px !important',
      margin: '-1px !important',
      padding: '0 !important',
      border: '0 !important',
    },
  };

  return <MuiGlobalStyles {...props} styles={stylesObj} />;
};
